import { set } from 'lodash';

/**
 * The duration picker value to process
 */
export class DurationValue {
  /**
   * The days count
   */
  days: number | undefined;

  /**
   * The hours count
   */
  hours: number | undefined;

  /**
   * The minutes count
   */
  minutes: number | undefined;

  /**
   * The seconds count
   */
  seconds: number | undefined;

  /**
   * Creates an instance of class.
   * @param duration The duration on the following format: `d.hh:mm:ss`
   */
  constructor(duration?: string) {
    let parts = [];
    if (duration) {
      const regex = /((\d+)\.)?(\d\d):([0-5][0-9]):([0-5][0-9])/;
      if (regex.test(duration)) {
        parts = regex.exec(duration);
      }
    }

    const numberOrUndefined = (input: string | undefined): number | undefined => {
      const parsed = parseInt(input);
      return isNaN(parsed) ? undefined : parsed;
    };
    let index = parts.length - 1;
    // TODO: Use typed-path here
    ['seconds', 'minutes', 'hours', 'days'].forEach((field: keyof DurationValue) => set(this, field, numberOrUndefined(parts[index--])));
  }

  toString(): string {
    const padLeft = (input: number | undefined): string => {
      return input === undefined ? '00' : input < 10 ? '0' + input : '' + input;
    };
    return `${this.days || 0}.${padLeft(this.hours || 0)}:${padLeft(this.minutes || 0)}:${padLeft(this.seconds || 0)}`;
  }
}
